import { useEffect, useMemo } from "react";
import HomeGoogleAds from "../../components/advertisement/home-google-ads";
import LoadHomeGoogleAds from "../../components/advertisement/load-home-google-ads";
import Header404Component from "./component/404-header.component";
import NotFoundLogin from "./component/404-login.component";
import NotFoundSimpleCallout from "./component/404-simple-callout.component";
import NotFoundSmartSearchBox from "./component/404-smart-search.component";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";

const ErrorBoundary = () => {
  const cachedGoogleAds = useMemo(() => <HomeGoogleAds />, []);
  const cachedUseDfpSlot = useMemo(() => <LoadHomeGoogleAds />, []);
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const path = "%2F404";

  const dispatch = useAppDispatch();
  
  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <div className="brand-texture">
        <Header404Component isProhibited={false} />
        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <NotFoundLogin isLoginPage={false} />
            </div>
          </div>
        </div>
        <NotFoundSmartSearchBox />
        <NotFoundSimpleCallout />
      </div>
      <p>&nbsp;</p>
      {cachedGoogleAds}
      {cachedUseDfpSlot}
      <p>&nbsp;</p>
    </>
  );
};

export default ErrorBoundary;
